<template>
  <div class="form-line" :class="{'-error': validations.find( o => o.condition )}">
    <fieldset v-if="options.length" :aria-describedby="validations.find( o => o.condition ) ? 'error-' + id : false">
      <legend :class="{'a11y-sr-only': !visibleLegend, 'form-legend': !!visibleLegend}">
        {{ !!visibleLegend ? visibleLegend : name }}
      </legend>
      <ul class="checkboxes" :class="{ '-inline' : inline }">
        <li class="checkbox" v-for="(checkbox, key) in options" :key="key">
          <input
            type="checkbox"
            :id="checkbox.id"
            :value="checkbox.value"
            :name="name"
            :checked="isChecked(checkbox.value)"
            @keyup.enter="$emit('click')"
            @click="$emit('click')"
            @blur="$emit('blur')"
            @change="onOptionChange($event, checkbox.value)"
            :disabled="disabled"
            :required="required ? true : false"
            :aria-required="required ? true : false"
            :aria-invalid="validations.find( o => o.condition ) ? true : false"
          >
          <label :for="checkbox.id">{{ checkbox.label }}</label>
        </li>
      </ul>
    </fieldset>
    <div v-else class="checkbox">
      <!-- Just one checkbox like to sign up newsletter -->
      <input
        type="checkbox"
        :id="id"
        :name="name"
        :checked="value"
        @keyup.enter="$emit('click')"
        @click="$emit('click')"
        @blur="$emit('blur')"
        @change="$emit('change', $event.target.checked)"
        :disabled="disabled"
        :required="required ? true : false"
        :aria-required="required ? true : false"
        :aria-invalid="validations.find( o => o.condition ) ? true : false"
        :aria-describedby="validations.find( o => o.condition ) ? 'error-' + id : false"
      >
      <label :for="id"><slot /></label>
    </div>
    <ValidationMessages v-if="validations" :validations="validations" :id="options.length ? options[0].id : id" />
  </div>
</template>

<script>
import ValidationMessages from './ValidationMessages.vue'

export default {
  name: 'BaseCheckbox',
  components: {
    ValidationMessages
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    id: {
      type: String,
      required: true
    },
    inline: {
      type: Boolean,
      required: false,
      default: false
    },
    options: {
      type: Array,
      required: false,
      default: () => []
    },
    visibleLegend: {
      type: String,
      required: false,
      default: ''
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      type: [String, Boolean, Array],
      required: true
    },
    validations: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    isChecked (optionValue) {
      return Array.isArray(this.value)
        ? this.value.includes(optionValue)
        : optionValue === this.value
    },
    onOptionChange (event, optionValue) {
      if (!Array.isArray(this.value)) {
        this.$emit('change', optionValue)
        return
      }

      const nextValue = event.target.checked
        ? [...this.value, optionValue]
        : this.value.filter(item => item !== optionValue)

      this.$emit('change', nextValue)
    }
  }
}
</script>
